<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.4"
      d="M12.5 21C7.25329 21 3 16.7467 3 11.5C3 6.25329 7.25329 2 12.5 2C17.7467 2 22 6.25329 22 11.5C22 16.7467 17.7467 21 12.5 21Z"
      :fill="'var(--primary-c600)'" fill-opacity="1" />
    <path
      d="M2.69945 22.0001C2.87945 22.0001 3.05945 21.9301 3.18945 21.8001L5.04945 19.9401C5.31945 19.6701 5.31945 19.2301 5.04945 18.9501C4.77945 18.6801 4.33945 18.6801 4.05945 18.9501L2.19945 20.8101C1.92945 21.0801 1.92945 21.5201 2.19945 21.8001C2.33945 21.9301 2.51945 22.0001 2.69945 22.0001Z"
      :fill="'var(--primary-c600)'" fill-opacity="1" />
  </svg>
</template>